// Block D: the Contacts page's tags and categories, and the pastel each one is drawn in.
//
// Colours are TOKEN NAMES (src/ui/tokens), never hex: a card's band, a tab and a chip all take the
// same token. A custom tag's colour is the one chosen in Edit tags (preferences.crmTagColors), else
// one picked from the palette by the tag's name, so it is the same on every load and every screen.

export const PRESET_TAGS = ['Client', 'Press', 'Team', 'Vendor', 'Partner', 'Prospect', 'Media', 'Investor'];
export const PERSONAL_CATEGORIES = ['Healthcare', 'School', 'Salon and beauty', 'Trades', 'Clubs and activities', 'Family and friends', 'Other'];

// The pastels a tag may take (all real tokens; v() throws on anything else).
export const TAG_PALETTE = [
  'pastel-green', 'pastel-blue', 'pastel-yellow', 'pastel-orange', 'pastel-pink',
  'pastel-lilac', 'pastel-periwinkle', 'pastel-coral', 'pastel-mint', 'pastel-neutral',
];

const FIXED = {
  Client: 'pastel-green', Prospect: 'pastel-yellow', Partner: 'pastel-orange', Press: 'pastel-coral',
  Media: 'pastel-pink', Team: 'pastel-mint', Vendor: 'pastel-lilac', Investor: 'pastel-periwinkle',
  New: 'pastel-blue', Untagged: 'pastel-neutral',
  Healthcare: 'pastel-mint', School: 'pastel-yellow', 'Salon and beauty': 'pastel-pink', Trades: 'pastel-orange',
  'Clubs and activities': 'pastel-lilac', 'Family and friends': 'pastel-coral', Other: 'pastel-neutral',
};

// A stable pick for a tag nobody has coloured: the same name always lands on the same pastel.
function hashPick(name) {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 31 + name.charCodeAt(i)) | 0;
  return TAG_PALETTE[Math.abs(h) % (TAG_PALETTE.length - 1)];   // never neutral: that is "Untagged"
}

// colors: preferences.crmTagColors, { [tag]: tokenName }. An unknown token is ignored.
export function tagColor(tag, colors = {}) {
  const chosen = colors && colors[tag];
  if (chosen && TAG_PALETTE.includes(chosen)) return chosen;
  return FIXED[tag] || hashPick(String(tag || ''));
}

// The tag a contact is filed under on its card: Client first, else its first tag, else "New" for
// a new contact, else "Untagged".
export function primaryTag(contact, isPersonal = false) {
  const tags = Array.isArray(contact?.tags) ? contact.tags : [];
  if (isPersonal) return tags.find((t) => PERSONAL_CATEGORIES.includes(t)) || tags[0] || 'Untagged';
  if (tags.includes('Client')) return 'Client';
  if (tags.length) return tags[0];
  return contact?.isNew ? 'New' : 'Untagged';
}

// Tags with Client first, the order the card and the drawer show them in.
export function orderedTags(tags) {
  return [...(Array.isArray(tags) ? tags : [])].sort((a, b) => (a === 'Client' ? -1 : b === 'Client' ? 1 : 0));
}
